import { extendTheme } from '@chakra-ui/react';

import APP_CONSTANTS from '@/utils/constants/app.constants';

export const theme = extendTheme({
  styles: {
    global: {
      '*': {
        animation: !APP_CONSTANTS.SHOW_ANIMATIONS && 'none !important',
        transition: !APP_CONSTANTS.SHOW_ANIMATIONS && 'none !important',
        margin: 0,
        padding: 0,
        outline: 0,
        boxSizing: 'border-box',
      },
      '#root': {
        margin: '0 auto',
      },
      html: {
        backgroundSize: 'cover',
      },
    },
  },
  colors: {
    primary: '#FF7F68',
    livelinx: {
      text: '#4E3D81',
      black100: '#7A7687',

      darkgrey: '#404040',

      purple50: '#f3f8ff',
      purple75: '#D6DAFF',
      purple100: '#6971FE',
      purple200: '#4E3D81',
      purple400: '#34334F',
      red: '#ff0000',
      lightgray: '#BFCEFF',
      lightgray100: '#e9e9eb',
      blue50: '#e6f4ff',
      blue100: '#c5d4ff',
      blue150: '#91caff',
      blue200: '#87b5ff',
      blue300: '#4B75FF',
      blue400: '#0958d9',

      grey100: '#f5f5f5',
      grey200: '#7A7687',
      grey300: '#E4EFFF',

      green: '#219653',
      green50: '#f6ffed',
      green100: '#b7eb8f',
      green200: '#389e0d',

      yellow200: '#FCBD53',

      orange200: '#FF7F68',
      orange200Opacity20: '#FF876820',
      orange200Opacity40: '#FF876840',
    },
  },

  shadows: {
    smallTop: '0 -3px 5px 0px rgba(159, 122, 234, 0.2)',
    blueShadow: '0px 2px 10px 2px rgba(0, 4, 255, 0.05)',
    white: '0px 0px 50px 0px #5A6CEA14',
    sidebar: '0 0px 30px -5px rgba(0, 0, 0, 0.13),0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },

  fonts: {
    heading: 'poppins-bold',
    body: 'nunito-bold',
  },

  components: {
    Text: {
      variants: {
        caseTitle: {
          color: 'livelinx.purple200',
          fontSize: '17px',
          fontFamily: 'poppins-bold',
        },
        meetingReportChunkTitle: {
          color: 'livelinx.purple200',
          fontSize: '22px',
          fontFamily: 'poppins-bold',
        },
        purpleTitleBold: {
          color: 'livelinx.purple200',
          fontFamily: 'poppins-bold',
        },
        purpleTitle: {
          color: 'livelinx.purple200',
          fontFamily: 'poppins-regular',
        },
        graySubTitle: {
          color: 'livelinx.grey200',
          fontFamily: 'nunito-regular',
          fontSize: '17px',
        },
      },
    },
    Tag: {
      baseStyle: {
        container: {
          borderRadius: '10px',
          userSelect: 'none',
          boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    Button: {
      baseStyle: {
        borderRadius: '10px',
        fontWeight: 'bold',
      },
      variants: {
        primary: {
          boxShadow: '0 2px #0000000b',
          background: 'primary',
          color: 'white',
          border: '1px solid',
          borderRadius: '10px',
          fontFamily: 'heading',
          fontWeight: 'bold',
          transition: '0.3s all',
          _hover: {
            color: 'primary',
            background: 'white',
            borderColor: 'primary',
          },
        },
        secondary: {
          background: 'white',
          fontFamily: 'heading',
          color: 'livelinx.purple200',
          border: '1px solid',
          borderRadius: '10px',
          borderColor: 'livelinx.lightgray',
          fontWeight: 'bold',
          _hover: {
            background: 'livelinx.purple200',
            color: 'white',
          },
        },
        blue: {
          background: 'blue.500',
          color: 'white',
          border: '1px solid',
          borderRadius: '5px',
          borderColor: 'blue.500',
          _hover: {
            background: 'blue.600',
            color: 'white',
          },
        },

        startMeeting: {
          background: 'transparent',
          color: 'primary',
          border: '2px dashed',
          borderColor: 'primary',
          backgroundColor: 'white',
          _hover: {
            background: 'primary',
            borderColor: 'white',
            color: 'white',
          },
        },

        slideNavigator: {
          backgroundColor: 'livelinx.blue100',
          color: 'livelinx.purple200',
          height: '50px',
          width: '100%',
          fontSize: '20px',
          borderRadius: '9px',
          _hover: {
            background: 'livelinx.purple200',
            color: 'white',
          },
        },
        slideNavigatorSelected: {
          backgroundColor: 'livelinx.purple200',
          color: 'white',
          height: '50px',
          width: '100%',
          fontSize: '20px',
          borderRadius: '9px',
          _hover: {
            background: 'livelinx.purple200',
            color: 'white',
          },
        },

        meetingStats: {
          backgroundColor: 'livelinx.blue300',
          borderRadius: '100px',
          _hover: {
            backgroundColor: 'livelinx.blue200',
          },
        },

        danger: {
          borderColor: '#ff4d4f',
          background: '#ff4d4f',
          boxShadow: '0 2px #0000000b',
          textShadow: '0 -1px 0 rgb(0 0 0 / 12%)',
          color: '#fff',
        },

        light: {
          border: '1px',
          borderColor: 'gray.200',
          background: '#fff',
        },
      },
    },

    Progress: {
      baseStyle: {
        filledTrack: {
          bg: 'livelinx.purple200',
        },
      },
      variants: {
        answers: {
          filledTrack: {
            bg: 'livelinx.purple100',
          },
        },
      },
    },
  },
});
